module.exports = __webpack_public_path__ + "media/images/pages/careers-support/benchmark_2-5977aeae86de8610529aa6db3b2f4eda.svg";